/**
 * @fileoverview Audit Log query keys.
 * @description Every Audit query sits under the `['audit']` prefix, so one invalidation refreshes
 * the event list and any open event's detail together.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const AUDIT_QUERY_KEY = ['audit'] as const

export const AUDIT_QUERY_KEYS = {
  events: [...AUDIT_QUERY_KEY, 'events'] as const,
  detail: (auditEventId: string) => [...AUDIT_QUERY_KEY, 'detail', auditEventId] as const,
}
